module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("In The Media")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "btn active"
  }, [_vm._v("News (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("Scientific Blogs (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("Google+ (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Citations:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })])])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Social Attention:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Total Shares")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "img h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "img h3"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adeb886c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/MediaPage.vue
// module id = 1469
// module chunks = 1